<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ftit"><a id="page_ix"></a>Money</h2>
<p class="noindent">Twelve pennies (written d for <em class="italic">denarii</em>) made one shilling (s), and 20 shillings made one pound (£ or l for <em class="italic">librae</em>), i.e. 240d. Another unit of accounting was the mark, which was two-thirds of a pound and consisted of 160d or 13s and 4d. In the fourteenth century, a labourer typically earned 2d a day or £3 a year, and a master craftsman 6d a day.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Money.vue?6940b26c